import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/31_mountains/31_mountains"
 * Contains 1 texture(s)
 */
export class Desktop31MountainsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/31_mountains/31_mountains';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '31_mountains.jpg'
    ] as const;
}
